import { comparisonFeatures } from '@/mocks/leistungen';

export default function ComparisonTable() {
  const renderValue = (val: boolean | string) => {
    if (val === true) {
      return (
        <span className="w-6 h-6 flex items-center justify-center bg-rose/15 rounded-full mx-auto">
          <i className="ri-check-line text-rose text-sm" />
        </span>
      );
    }
    if (val === false) {
      return (
        <span className="w-6 h-6 flex items-center justify-center mx-auto">
          <i className="ri-subtract-line text-charcoal/25 text-sm" />
        </span>
      );
    }
    return (
      <span className="font-sans text-sm font-medium text-charcoal">{val}</span>
    );
  };

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            Vergleich
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            Was ist enthalten?
          </h2>
          <p className="font-sans text-base text-charcoal/60 max-w-md mx-auto leading-relaxed">
            Finde die Behandlung, die am besten zu deinen Wünschen passt.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-2xl ring-1 ring-blush">
          <table className="w-full min-w-[560px]">
            <thead>
              <tr className="bg-charcoal">
                <th className="text-left px-6 py-4 font-sans text-sm font-medium text-white/70 w-[40%]">
                  Leistung
                </th>
                <th className="text-center px-4 py-4 font-sans text-sm font-medium text-white/70">
                  Starter
                  <div className="font-serif text-lg font-medium text-rose mt-0.5">99€</div>
                </th>
                <th className="text-center px-4 py-4 font-sans text-sm font-medium text-white/70 bg-rose/20">
                  Classic
                  <div className="font-serif text-lg font-medium text-rose mt-0.5">149€</div>
                </th>
                <th className="text-center px-4 py-4 font-sans text-sm font-medium text-white/70">
                  Premium
                  <div className="font-serif text-lg font-medium text-rose mt-0.5">199€</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonFeatures.map((row, i) => (
                <tr
                  key={i}
                  className={i % 2 === 0 ? 'bg-offwhite' : 'bg-white'}
                >
                  <td className="px-6 py-4 font-sans text-sm text-charcoal font-medium">
                    {row.feature}
                  </td>
                  <td className="px-4 py-4 text-center">
                    {renderValue(row.starter)}
                  </td>
                  <td className="px-4 py-4 text-center bg-rose/5">
                    {renderValue(row.classic)}
                  </td>
                  <td className="px-4 py-4 text-center">
                    {renderValue(row.premium)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Note */}
        <p className="font-sans text-xs text-charcoal/50 text-center mt-4">
          * Alle Behandlungen sind peroxidfrei und entsprechen der EU-Kosmetikverordnung.
        </p>
      </div>
    </section>
  );
}
